export default {"src":"/login-app/[GIT_HASH]/_next/static/media/more_horiz.81d83d6e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};